import { render, staticRenderFns } from "./leadsForm.vue?vue&type=template&id=3dfca9f6"
import script from "./leadsForm.vue?vue&type=script&lang=js"
export * from "./leadsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports